<template>
  <div>
    <SyAccessoryFile
    v-bind="{ ...props }"
    v-on="$listeners"
    :onlyImage="onlyImage"
    :ediTable='!isPureText'
    :firstImgOnly="firstImgOnly"
    :isChunk="isChunk"
    :multiple="multiple"
    :limit="maxUploadNum"
    acceptType="IMAGE"
    :checkRule="aPaasCheckInfo"
    listType="picture-card"
    :disabled="disabled"
    :on-success="handleUploadSuccess"
    :on-remove="handleUploadRemove"
    :fileList="fileList"
    :permission="permission"
  ></SyAccessoryFile>
  </div>
</template>

<script>
  import Store from '../../../utils/catch-state.js'
  import SyAccessoryFile from '../../../../../basis/sy-accessory/sy-accessory.vue'
  import { imageProps } from './index.js'

  // 私有照片 url //img.sunyur.com/160674628808875779.svg
  export default {
    name: 'image-upload',
    model: {
      event: 'change',
      prop: 'fileList'
    },
    props: imageProps,
    data () {
      return {
        aPaasCheckInfo: ''
      }
    },
    components: {
      SyAccessoryFile
    },
    methods: {
      getRandomNumber () {
        return parseInt(Math.random() * 1e10)
      },
      handleUploadSuccess (res, file, fileList) {
        file.filePath = res.content.filePath
        file.openUrl = res.content.openUrl
        file.key = res.content.key
        this.$emit('change', fileList)
        this.$emit('validateField')
      },
      handleUploadRemove (file, fileList) {
        this.$emit('change', fileList)
        this.$emit('validateField')
      },
      async _getCheckInfo () {
        let fileInfos = await Store.paasUpload('fileInfos').getter()
        const {apiName, objectApiName} = this.data
        if (fileInfos[`${objectApiName}_${apiName}`]) {
          this.aPaasCheckInfo = fileInfos[`${objectApiName}_${apiName}`]
        } else {
          let res = await Store.paasUpload('getCheckInfo').getter(this.data)
          if (res.isOk) {
            this.aPaasCheckInfo = res.content
            fileInfos[`${objectApiName}_${apiName}`] = res.content
            Store.paasUpload('fileInfos').update(fileInfos)
          }
        }
      }
    },
    mounted () {
      if (!this.isPureText) {
        this.fileList.forEach(item => {
          this.$set(item, 'url', item.openUrl || item.fileUrl)
          item.uid = this.getRandomNumber()
        })
        this._getCheckInfo()
      }
    }
  }
</script>

<style lang="scss" scoped>
::v-deep .sy-accessory {
  overflow: visible;
}
</style>
